import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="py-24 px-6">
      <Seo title="Page introuvable — Koranex" description="La page que vous recherchez n'existe pas ou a été déplacée." />
      <div className="max-w-2xl mx-auto text-center">
        <span className="font-display text-8xl sm:text-9xl text-[#1d4ed8] block mb-6">404</span>
        <h1 className="font-display text-3xl sm:text-5xl text-white mb-4">Page introuvable</h1>
        <p className="text-sm text-slate-400 mb-10">
          La page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="px-8 py-4 rounded-xl bg-[#1d4ed8] hover:bg-blue-600 text-white font-mono-x text-xs uppercase tracking-wider font-bold transition-colors"
          >
            Retour à l'accueil
          </Link>
          <Link
            to="/contact"
            data-testid="not-found-contact-link"
            className="px-8 py-4 rounded-xl bg-[#0f172a] hover:bg-slate-800 border border-slate-800 text-slate-300 font-mono-x text-xs uppercase tracking-wider transition-colors"
          >
            Nous contacter
          </Link>
        </div>
      </div>
    </div>
  );
}
